/**
   * Enum loại chi - dùng cho view nộp dự toán
   */
export default {
    Invest: 1, //đầu tư
    Regular: 2, //thường xuyên
    Project: 3, //CTMT
    CalculationBasis: 4, //cơ sở tính
    Other: 5, //chi khác
    
    /// <summary>
    /// Thu phí, lệ phí
    /// </summary>
    RevenueFees: 6,

    /// <summary>
    /// Thu HDSNDV
    /// </summary>
    RevenueBusiness: 7,

    /// <summary>
    /// Chi HDSNDV
    /// </summary>
    ExpenseBusiness: 8,

    /// <summary>
    /// Chi phí, lệ phí
    /// </summary>
    ExpenseFees: 9
}